import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { HowToTextPageRoutingModule } from './how-to-text-routing.module';

import { HowToTextPage } from './how-to-text.page';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, HowToTextPageRoutingModule, TranslateModule.forChild()],
  declarations: [HowToTextPage]
})
export class HowToTextPageModule {}
